import React from 'react';
import { styled} from '@mui/system';
import { GovContainer } from "@gov-design-system-ce/react";

export interface ContainerProps {
    children?: React.ReactNode;
}

const StyledGovContainer = styled(GovContainer)<ContainerProps>(() => ({
    display: 'block',
    overflow: 'hidden',
    padding: '2.5rem 1.25rem',
    width: '100%',
}));

export default function Container(props: ContainerProps) {
    const { children } = props;

    return (
        <StyledGovContainer>
            <div>
                {children}
            </div>
        </StyledGovContainer>
    );
}